module.exports = __webpack_public_path__ + "static/media/react.b6896736.webp";